document.querySelectorAll(".ct-product").forEach(card=>{

const buttons=card.querySelectorAll(".ct-size-btn");

const input=card.querySelector(".selected-variant");

buttons.forEach(btn=>{

btn.addEventListener("click",()=>{

buttons.forEach(b=>b.classList.remove("active"));

btn.classList.add("active");

input.value=btn.dataset.variant;

});

});

});

document.addEventListener("DOMContentLoaded", () => {

    function initCompleteLook() {

        document.querySelectorAll(".ct-add").forEach(button => {

            button.addEventListener("click", async function () {

                const card = this.closest(".ct-product");

                const variant = card.querySelector(".selected-variant").value;

                const originalText = this.innerHTML;

                this.disabled = true;
                this.innerHTML = "Adding...";

                try {

                    const response = await fetch("/cart/add.js", {

                        method: "POST",

                        headers: {
                            "Content-Type": "application/json",
                            "Accept": "application/json"
                        },

                        body: JSON.stringify({
                            id: variant,
                            quantity: 1
                        })

                    });

                    if (!response.ok) throw new Error();

                    this.innerHTML = "✓ Added";

                    document.dispatchEvent(
                        new CustomEvent("cart:refresh")
                    );

                    setTimeout(async () => {

                        try {

                            const cartResponse = await fetch("/cart?view=drawer");

                            if(cartResponse.ok){

                                location.reload();

                            }else{

                                location.reload();

                            }

                        } catch (e) {

                            location.reload();

                        }

                    },600);

                } catch (e) {

                    this.innerHTML = "Try Again";

                    setTimeout(() => {

                        this.disabled = false;
                        this.innerHTML = originalText;

                    },1500);

                }

            });

        });

    }

    initCompleteLook();

});